"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _identifier = require("../../util/identifier");
var _Checkbox = require("../Checkbox/Checkbox");
var _FormField = require("../FormField/FormField.context");
var _SwitchWrapper = require("../SwitchWrapper/SwitchWrapper");
var _Switch = require("./Switch.styles");
var _excluded = ["checkbox", "controlId", "size"];
/**
 * A switch is on/off control built upon a simple checkbox input.
 *
 * @related ['Checkbox', 'FieldSet', 'LabeledControl']
 * @subcomponents ['SwitchGroup']
 * @since 6.7.0
 */
var Switch = function Switch(_ref) {
  var checkbox = _ref.checkbox,
    controlId = _ref.controlId,
    size = _ref.size,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var context = (0, _react.useContext)(_FormField.FormFieldContext);

  // defaultId is used as the id for the control and the htmlFor for the label
  var defaultId = (0, _react.useRef)((0, _identifier.identifier)()).current;
  var id = checkbox.props.id || controlId || context.controlId || defaultId;
  var disabled = typeof rest.disabled !== 'undefined' ? rest.disabled : context.disabled;
  return /*#__PURE__*/_react.default.createElement(_SwitchWrapper.SwitchWrapper, null, /*#__PURE__*/(0, _react.cloneElement)(checkbox, {
    id: id,
    offscreen: true,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(_Switch.StyledSwitch, (0, _extends2.default)({
    htmlFor: id
  }, rest, {
    "aria-disabled": disabled,
    size: size || context.size || _constants.SWITCH_SIZES.md
  })));
};
exports.Switch = Switch;
Switch.displayName = 'Switch';
Switch.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Identifier used to associate form controls and labels. If this is not defined, an identifier
   * will be automatically generated.
   */
  controlId: _propTypes.default.string,
  /**
   * A `Checkbox` instance.
   */
  checkbox: _customPropTypes.default.instanceOfComponent(_Checkbox.Checkbox).isRequired,
  /**
   * The size of the switch, defaults to `SWITCH_SIZES.md`. Can also be inherited from a
   * FieldSet parent.
   */
  size: _propTypes.default.oneOf(Object.values(_constants.SWITCH_SIZES)),
  /**
   * Displays the switch in a disabled state. Can also be inherited from a LabeledControl
   * or FieldSet parent.
   */
  disabled: _propTypes.default.bool
} : {};
Switch.defaultProps = {
  controlId: undefined,
  disabled: undefined
};